import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { CandidateInterviewsContainerContent } from './CandidateInterviewsContainerContent';

interface CandidateInterviewsContainerProps {
  orgId: string;
  candidateId: string;
}

export function CandidateInterviewsContainer(props: CandidateInterviewsContainerProps) {
  return (
    <QueryErrorBoundary>
      <CandidateInterviewsContainerContent {...props} />
    </QueryErrorBoundary>
  );
}
